import React, { Component } from 'react'
import styles from './style.module.less'
import auth, { ONLINE_STORE } from '../../auth'
import { SHOP_PRODUCTS_PATH_A } from '@constant'
import { getMerchantInfo, getProTitle } from '@util'
import moment from 'moment'

/** 线上店铺 */
@auth(ONLINE_STORE)
export default class extends Component {
  render() {
    const { pro_date, examine } = getMerchantInfo() || {}
    const date = (pro_date || '').split(' ')[0]

    const diff = moment(date).diff(moment(), 'days')
    return (
      <div className={styles.wrapper}>
        <div className={styles.title}>店铺服务费</div>
        {!!examine &&
          (diff > 30 ? (
            <div className={styles.endDate}>
              将于 <span className={styles.date}>{date}</span> 到期
            </div>
          ) : (
            <div className={styles.endDate}>
              剩余<span className={styles.date}>{diff + 1}</span>天可用
            </div>
          ))}
        <div className={styles.detail}>
          开通{getProTitle()}，独享营销神器，客资转化+经营效率，全面飞跃
        </div>
        <a className={styles.btn} href={SHOP_PRODUCTS_PATH_A}>
          立即开通
        </a>
      </div>
    )
  }
}
